import { ANIMATION_DURATION } from '@/constants/register.contants'
import BaseTextField from '@/shared/components/Inputs/BaseTextField'
import { Box, Button, Grow, Paper, Stack, Typography } from '@mui/material'
import { IconArrowUp } from '@tabler/icons-react'
import React, { useState } from 'react'

export const UserForm: React.FC<UserFormProps> = ({ onFormSubmit }) => {
  const [formValues, setFormValues] = useState<UserInfo>({
    name: '',
    email: '',
    organization: '',
  })
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    organization: false,
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormValues({
      ...formValues,
      [name]: value,
    })
  }

  const validateForm = () => {
    const newErrors = {
      name: !formValues.name,
      email: !formValues.email || !/\S+@\S+\.\S+/.test(formValues.email),
      organization: !formValues.organization,
    }

    setErrors(newErrors)
    return !Object.values(newErrors).some(Boolean)
  }

  const handleSubmit = () => {
    if (validateForm()) {
      onFormSubmit(formValues)
    }
  }

  return (
    <Grow in={true} timeout={ANIMATION_DURATION}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          width: '100%',
          position: 'relative',
        }}
      >
        <Stack spacing={2}>
          <Box>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
              Nice to meet you, I'm
            </Typography>
            <BaseTextField
              name="name"
              value={formValues.name}
              onChange={handleChange}
              placeholder="Type your name here"
              error={errors.name}
              helperText={errors.name ? 'Name is required' : ''}
            />
          </Box>
          <Box>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
              You can reach me via email at
            </Typography>
            <BaseTextField
              name="email"
              type="email"
              value={formValues.email}
              onChange={handleChange}
              placeholder="Type your email here"
              error={errors.email}
              helperText={errors.email ? 'Valid email is required' : ''}
            />
          </Box>
          <Box>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
              My organization is
            </Typography>
            <BaseTextField
              name="organization"
              value={formValues.organization}
              onChange={handleChange}
              placeholder="Type your organization here"
              error={errors.organization}
              helperText={errors.organization ? 'Organization is required' : ''}
            />
          </Box>
        </Stack>
        <Button
          variant="outlined"
          onClick={handleSubmit}
          sx={{
            position: 'absolute',
            bottom: 10,
            right: 10,
            borderRadius: 12,
            minWidth: 35,
            borderWidth: 2,
            p: 1,
          }}
        >
          <IconArrowUp size={18} stroke={4} />
        </Button>
      </Paper>
    </Grow>
  )
}
